import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-205d43ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " 오시는길 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ContactMap = _resolveComponent("ContactMap")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("main", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickMain && _ctx.onClickMain(...args)))
  }, [
    _createVNode(_component_Header, { "screen-info": _ctx.screenInfo }, null, 8, ["screen-info"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_ContactMap, {
        platform: _ctx.screenInfo.isPlatform
      }, null, 8, ["platform"])
    ]),
    _createVNode(_component_Footer, { "screen-info": _ctx.screenInfo }, null, 8, ["screen-info"])
  ]))
}